const anchorSelector = '[data-s-anchor]'
const childSelector = '[data-s-child]'

let objects = undefined

/*
 * Easing Functions - inspired from http://gizma.com/easing/
 * only considering the t value for the range [0, 1] => [0, 1]
 */
let easingFunctions = {
    linear: t => t,
    easeInQuad: t => t * t,
    easeOutQuad: t => t * (2 - t),
    easeInOutQuad: t => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: t => t * t * t,
    easeOutCubic: t => (--t) * t * t + 1,
    easeInOutCubic: t => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuart: t => t * t * t * t,
    easeOutQuart: t => 1 - (--t) * t * t * t,
    easeInOutQuart: t => t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t,
    easeInQuint: t => t * t * t * t * t,
    easeOutQuint: t => 1 + (--t) * t * t * t * t,
    easeInOutQuint: t => t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
}

function init() {
    objects = document.querySelectorAll(anchorSelector)
    update()

    let calculating = false

    document.addEventListener('scroll', () => {
        if (document.documentElement.clientWidth < 800) return

        if (calculating) return
        calculating = true

        window.requestAnimationFrame(function () {
            update()
            calculating = false
        })
    })

    window.addEventListener('resize', () => {
        if (document.documentElement.clientWidth < 800) {
            reset()
            return
        }
        if (calculating) return
        calculating = true

        window.requestAnimationFrame(function () {
            update()
            calculating = false
        })
    })
}

function clamp(n, min, max) {
    n = n < min ? min : n
    n = n > max ? max : n
    return n
}

function ease(n, fnName) {
    fnName = fnName || 'linear'
    if (n < 0 || n > 1) n = clamp(n, 0, 1)

    if (!easingFunctions[fnName]) throw 'unknown easing function ' + fnName

    return easingFunctions[fnName](n)
}

function reset() {
    let children = document.querySelectorAll(childSelector);
    [].forEach.call(children, child => {
        child.style.transform = `translateY(0px)`
        child.style.opacity = "1"
    });
}

function update() {
    [].forEach.call(objects, object => {
        let position = calculateScroll(object)
        animate(object, position)
    });
}

function calculateScroll(object) {
    let vh = document.documentElement.clientHeight
    let position = object.getBoundingClientRect()

    let y = position.y

    switch (object.getAttribute('data-s-anchor-origin')) {
    case 'top':
        y = position.y
        break
    case 'center':
        y = position.y + position.height / 2
        break
    case 'bottom':
        y = position.y + position.height
        break
    default:
        y = position.y
        break
    }

    let scrollAmount = document.documentElement.scrollTop || document.body.scrollTop
    let screenPosition = clamp((scrollAmount - y) / vh, 0, 1)
    return screenPosition
}

function animate(object, amount) {
    let children = object.querySelectorAll(childSelector);
    [].forEach.call(children, child => {
        let easeFn = child.getAttribute('data-s-easing-function')
        let easedValue = ease(amount, easeFn)
        let max = child.getAttribute('data-s-amount') || -200
        let pixels = Math.floor(easedValue * max)
        child.style.transform = `translateY(${pixels}px)`
        child.style.opacity = (1 - amount).toFixed(2)
    });
}

module.exports = {
    init
}



// WEBPACK FOOTER //
// ./modules/skrollr-replacement.js